import { useMemo } from "react";
import { createContext, useReducer } from "react";

export const IdentifiedSpeciesFiltersContext = createContext();
export const IdentifiedSpeciesFiltersDispatchContext = createContext();

const initialState = {
    filterDialogOpen: false,
    visibleSpeciesCt: 5,
    showAST: true,
    showKIDCalls: true,
    showAssemblyMetrics: true,
    showAlignmentMetrics: true,
    showAssemblyMBsToSpecies: true,
    showContigsToSpecies: true,
    showCoverageBreadth: true,
    showCoverageDepth: true,
    showCoverage5xDepth: true,
    showRnDModels: false,
    showImputedCalls: false,
    showResistanceGenes: false,
    loadingResistanceGenes: true,
    loadingImputations: true,
    forceShowIAndRCalls: false,
  };

const filtersReducer = (state, action) => {
    switch (action.type) {
        case 'SET_FILTER_DIALOG_OPEN':
            return {...state, filterDialogOpen: action.payload};
        case 'SET_VISIBLE_SPECIES_CT':
            return {...state, visibleSpeciesCt: action.payload};
        case 'SET_SHOW_AST':
            return {...state, showAST: action.payload};
        case 'SET_SHOW_KID_CALLS':
            return {...state, showKIDCalls: action.payload};
        case 'SET_SHOW_ALIGNMENT_METRICS':
            return {...state, showAlignmentMetrics: action.payload};
        case 'SET_SHOW_ASSEMBLY_METRICS':
            return {...state, showAssemblyMetrics: action.payload};
        case 'SET_SHOW_ASSEMBLY_MBS_TO_SPECIES':
            return {...state, showAssemblyMBsToSpecies: action.payload};
        case 'SET_SHOW_CONTIGS_TO_SPECIES':
            return {...state, showContigsToSpecies: action.payload};
        case 'SET_SHOW_COVERAGE_BREADTH':
            return {...state, showCoverageBreadth: action.payload};
        case 'SET_SHOW_COVERAGE_DEPTH': 
            return {...state, showCoverageDepth: action.payload};
        case 'SET_SHOW_COVERAGE_5X_DEPTH':
            return {...state, showCoverage5xDepth: action.payload};
        case 'SET_SHOW_RND_MODELS':
            return {...state, showRnDModels: action.payload};
        case 'SET_SHOW_IMPUTED_CALLS':
            return {...state, showImputedCalls: action.payload};
        case 'SET_SHOW_RESISTANCE_GENES':
            return {...state, showResistanceGenes: action.payload};
        case 'SET_LOADING_RESISTANCE_GENES':
            return {...state, loadingResistanceGenes: action.payload};
        case 'SET_LOADING_IMPUTATIONS':
            return {...state, loadingImputations: action.payload};
        case 'SET_FORCE_SHOW_I_AND_R_CALLS':
            return {...state, forceShowIAndRCalls: action.payload};
        default:
            return state;
    }
}

export const IdentifiedSpeciesFiltersProvider = ({ children }) => {
    const [state, dispatch] = useReducer(filtersReducer, initialState);

    // Memoize the dispatch functions to avoid unnecessary re-renders (dispatch never changes)
    const dispatchFuncs = useMemo(() => ({
        setFilterDialogOpen: (open) => dispatch({ type: 'SET_FILTER_DIALOG_OPEN', payload: open }),
        setVisibleSpeciesCt: (count) => dispatch({ type: 'SET_VISIBLE_SPECIES_CT', payload: count }),
        setShowAST: (show) => dispatch({ type: 'SET_SHOW_AST', payload: show }),
        setShowKIDCalls: (show) => dispatch({ type: 'SET_SHOW_KID_CALLS', payload: show }),
        setShowAlignmentMetrics: (show) => dispatch({ type: 'SET_SHOW_ALIGNMENT_METRICS', payload: show }),
        setShowAssemblyMetrics: (show) => dispatch({ type: 'SET_SHOW_ASSEMBLY_METRICS', payload: show }),
        setShowAssemblyMBsToSpecies: (show) => dispatch({ type: 'SET_SHOW_ASSEMBLY_MBS_TO_SPECIES', payload: show }),
        setShowContigsToSpecies: (show) => dispatch({ type: 'SET_SHOW_CONTIGS_TO_SPECIES', payload: show }),
        setShowCoverageBreadth: (show) => dispatch({ type: 'SET_SHOW_COVERAGE_BREADTH', payload: show }),
        setShowCoverageDepth: (show) => dispatch({ type: 'SET_SHOW_COVERAGE_DEPTH', payload: show }),
        setShowCoverage5xDepth: (show) => dispatch({ type: 'SET_SHOW_COVERAGE_5X_DEPTH', payload: show }),
        setShowRnDModels: (show) => dispatch({ type: 'SET_SHOW_RND_MODELS', payload: show }),
        setShowImputedCalls: (show) => dispatch({ type: 'SET_SHOW_IMPUTED_CALLS', payload: show }),
        setShowResistanceGenes: (show) => dispatch({ type: 'SET_SHOW_RESISTANCE_GENES', payload: show }),
        setLoadingResistanceGenes: (loading) => dispatch({ type: 'SET_LOADING_RESISTANCE_GENES', payload: loading }),
        setLoadingImputations: (loading) => dispatch({ type: 'SET_LOADING_IMPUTATIONS', payload: loading }),
        setForceShowIAndRCalls: (show) => dispatch({ type: 'SET_FORCE_SHOW_I_AND_R_CALLS', payload: show }),
    }), [dispatch]);

    return (
        <IdentifiedSpeciesFiltersContext.Provider value={state}>
            <IdentifiedSpeciesFiltersDispatchContext.Provider value={dispatchFuncs}>
                {children}
            </IdentifiedSpeciesFiltersDispatchContext.Provider>
        </IdentifiedSpeciesFiltersContext.Provider>
    );
}